import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';

import './YourTourNavItem.scss';

const YourTourNavItem = ({
  destination,
  label,
  Icon,
  onMouseEnter,
}) => {

  // maintain url params
  const { search } = useLocation();

  return (
    <NavLink
      to={`${destination}${search}`}
      className='main-nav__item'
      onMouseEnter={onMouseEnter}
    >
      <div className="main-nav__icon">
        {Icon && (<Icon />)}
      </div>
      <div className="main-nav__label">{label}</div>
    </NavLink>
  );
};

export default YourTourNavItem;
